export const PAGE_TITLE_V2_MAIN = 'Überblick | AI Analyse | finanzen.net zero';
